import { render, staticRenderFns } from "./TenderingGrid.vue?vue&type=template&id=2417fa66&"
import script from "./TenderingGrid.vue?vue&type=script&lang=js&"
export * from "./TenderingGrid.vue?vue&type=script&lang=js&"
import style0 from "./TenderingGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports